import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import formatPrismicData from '../../hocs/formatPrismicData';
import SaveForLater from './SaveForLater';
import { withFormik } from 'formik';
import { request } from '../../../../../common/rest/index';
import { getErrorMessage } from './helpers';
import withState from 'recompose/withState';
import { openSaveForLater, closeSaveForLater } from '../CanvasDrawers/duck';
import withHandlers from 'recompose/withHandlers';
import { withProps } from 'recompose';
import {
  trackSaveForLaterClickCta,
  trackSaveForLaterSubmitted,
  trackSaveForLaterOpen,
  trackSaveForLaterClose,
  trackSaveForLaterEmailInput
} from '../../../analytics/category/product';

const enhance = compose(
  formatPrismicData,
  withRouter,
  withState('isSubmitted', 'setIsSubmitted', false),
  withState('isOpen', 'setIsOpen', false),
  connect(null, dispatch => ({
    openSaveForLater: () => {
      dispatch(openSaveForLater());
      trackSaveForLaterOpen();
    },
    closeSaveForLater: () => {
      dispatch(closeSaveForLater());
      trackSaveForLaterClose();
    },
  })),
  withProps(props => {
    const { ctaIcon, saveForLaterCtaText } = props.data;

    return {
      ctaIcon: ctaIcon || props.ctaIconGlobalContent,
      ctaText: saveForLaterCtaText || props.ctaTextGlobalContent
    };
  }),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: props => ({
      email: '',
      previewUrl: `${props.canonicalUrl}${props.location.search}`,
      productId: props.productId,
      locale: props.locale,
      adventurersNames: props.adventurersNames,
    }),
    validateOnChange: false,
    handleSubmit: (payload, formikBag) => {
      const errorTranslations = formikBag.props.errorMessages;
      request.post(
        '/api/v1/save-for-later', payload, { headers: { 'content-type': 'application/json' } }
      )
        .then(() => {
          formikBag.props.setIsSubmitted(true);
          formikBag.setSubmitting(false);
          formikBag.resetForm();
          trackSaveForLaterSubmitted();
        })
        .catch(error => {
          formikBag.setSubmitting(false);
          const errors = error && getErrorMessage(error, errorTranslations);
          formikBag.setErrors(errors);
        });
    }
  }),
  withHandlers({
    handleToggle: props => () => {
      trackSaveForLaterClickCta();
      props.setIsOpen(!props.isOpen);
      if (!props.isOpen) {
        props.openSaveForLater();
      } else {
        props.closeSaveForLater();
        props.setIsSubmitted(false);
      }
    },
    handleEmailChange: props => event => {
      trackSaveForLaterEmailInput();
      props.handleChange(event);
    },
  }),
);

export default enhance(SaveForLater);



// WEBPACK FOOTER //
// ./src/client/js/view/components/SaveForLater/index.js